<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseButton from '../BaseButton/BaseButton.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { openOverpanel } from '../../stores/overpanelControl';
  import { getURL } from '../../utils/card-query';
  
  let {
    ariaTemplate,
    drug,
    name,
    code = undefined,
    displayPrice,
    crossedOutPrice = undefined,
    url = undefined,
    hasLocation = false,
    isGeneric = false,
    getURLVars = () => {},
    dataTestId = 'pricing-tile',
    lang,
  } = $props();

  const dataUmamiEvent = () => window.umami.track('pricing-tile', { pharmacy: code, drug: drug });

  const onClick = () => {
    dataUmamiEvent();

    openOverpanel('availableLocation', {
      drug: { ...getURLVars({ chainCode, chainLabel }), price: displayPrice },
    });
  };

  // if chain code is present we want to open overpanel
  let component = $derived(hasLocation ? BaseButton : BaseLink);
  let chainCode = $derived(code);
  let chainLabel = $derived(name);
  let componentProps = $derived(
    hasLocation
      ? { onClick, dataTestId }
      : { url: url || getURL({ ...getURLVars({ chainCode, chainLabel }), price: displayPrice, lang }), onClick: dataUmamiEvent, dataTestId }
  );

  let ariaLabel = $derived(ariaTemplate.replace(/{{PHARMACY}}/, name).replace(/{{PRICE}}/, displayPrice));

  const SvelteComponent = $derived(component);
</script>

<SvelteComponent
  {...componentProps}
  className="w-full my-4 mx-auto flex items-stretch min-h-18 lg:min-h-22 rounded-lg shadow-y-sm pseudo-shadow-hover 
  relative active:shadow-active border border-gray-light-silver"
  {ariaLabel}
>
  <div
    class="flex grow justify-center flex-col p-4 py-3 lg:p-5 bg-white min-h-18 lg:min-h-22 border-r
    border-gray-light-silver rounded-l-lg"
  >
    <div class="text-lg lg:text-2.5xl text-left leading-tight text-blue-navy">{chainLabel}</div>
  </div>
  <div
    class="flex flex-none flex-row w-30 sm:w-36 md:w-46 lg:w-53 min-h-full items-center pr-1 pl-0.5 sm:pl-1 py-4 rounded-r-lg"
    class:bg-blue-very-light={isGeneric}
    class:bg-gray-pale={!isGeneric}
  >
    <div
      class="flex-auto flex flex-col items-center w-30 sm:w-36 md:w-46 lg:w-53 justify-center pl-1 sm:pl-3 px-2 lg:pr-0"
    >
      <span
        class="flex-none text-right text-base md:text-2xl lg:text-2.5xl font-medium text-blue-cerulean leading-none"
      >
        <sup class="text-2xs md:text-sm -top-2">$</sup>
        {displayPrice}
      </span>
      {#if crossedOutPrice}
        <span data-testid="pricing-tile-crossed-out-price">
          <sup class="text-2xs md:text-xs -top-1">$</sup>
          <span class="text-sm md:text-lg line-through">{crossedOutPrice}</span>
        </span>
      {/if}
    </div>
    <svg class="flex-none w-4 h-4 lg:w-6 lg:h-6 lg:mr-3 fill-current text-blue-cerulean" role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
    </svg>
  </div>
</SvelteComponent>
